import { Store } from 'Application/Store/Store'
import { animationState, pauseAnimation } from './animationState'

let _intervalId = null
let _loop = true

export const startAnimationTimer = ({ speed, loop }) => {
  _loop = loop
  if (_intervalId) clearInterval(_intervalId)

  _intervalId = setInterval(() => {
    if (!animationState.play) return

    const { keyframe, times } = Store.getState().AnimationReducer
    const nextKey = times[keyframe + 1] ? keyframe + 1 : 0

    if (!_loop && nextKey === 0) {
      pauseAnimation()
      return
    }

    Store.dispatch({ type: 'ACTUAL_KEYFRAME', payload: nextKey })
  }, speed)
}

export const stopAnimationTimer = () => {
  if (_intervalId) {
    clearInterval(_intervalId)
    _intervalId = null
  }
}
